export default __webpack_public_path__ + "static/media/planpricingtooltip.a4e8ec41.svg";